<template>
   <div id="overlay">
       <div id="overlayTitle">
           <div id="name">{{name}}</div>
           <div id="location">{{location}}</div>
       </div>
       <div id="overlayContent">
           <div class="overlayContentHeader">Agency</div>
           <div class="overlayContentValue">{{agency}}</div>
           <div class="overlayContentHeader">Outcome</div>
           <div class="overlayContentValue">{{outcome}}</div>
           <div class="overlayContentHeader" v-if="narrative">Narrative</div>
           <div class="overlayContentValue" v-if="narrative">{{narrative}}</div>
           <div class="overlayContentHeader" v-if="sources.length">Sources</div>
           <div class="overlayContentValue" v-for="source in sources" :key="source.url">
               <a :href="source.url">{{source.name}}</a>
           </div>
           <div class="overlayContentHeader" v-if="media.length">Media</div>
           <div class="overlayContentValue" v-for="media_item in media" :key="media_item.url">
               <a :href="media_item.url">{{media_item.media_type}}</a>
            </div>
       </div>
   </div>
</template>

<style>
.leaflet-popup-content-wrapper {
    border: 2px solid black;
    border-radius: 0%;
}
.leaflet-popup-content-wrapper .leaflet-popup-content {
    margin: 0px !important;
    width: 250px;
}
</style>

<style scoped>
#overlay {
    height: 100%;
}
#overlayTitle {
    border-bottom: 2px solid black;
    padding-top: 6px;
    padding-bottom: 6px;
}
#overlayContent {
    max-height: 50vh;
    overflow: scroll;
}
.overlayContentHeader {
    margin-left: 15px;
    margin-right: 15px;
    font-weight: bold;
}
.overlayContentHeader:first-of-type {
    margin-top: 15px;
}
.overlayContentValue {
    margin-left: 15px;
    margin-right: 15px;
    margin-bottom: 10px;
}
.overlayContentValue:last-of-type {
    margin-bottom: 15px;
}
#name {
    margin-left: 15px;
    margin-right: 15px;
    margin-top: 5px;
    font-weight: bold;
    line-height: 1.1;
}
#location {
    margin-left: 15px;
    margin-right: 15px;
    margin-bottom: 5px;
    font-weight: bold;
    font-style: italic;
}
</style>

<script>
export default {
  name: 'Overlay',
  props: {
    name: String,
    location: String,
    agency: String,
    outcome: String,
    narrative: String,
    sources: Array,
    media: Array,
  },
};
</script>
